(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterDialogController', BulkMeterDialogController);

    BulkMeterDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'BulkMeter', 'UserSearch','ModelMeter','WaterNetwork'];

    function BulkMeterDialogController ($scope, $stateParams, $uibModalInstance, entity, BulkMeter, UserSearch,ModelMeter,WaterNetwork) {
        var vm = this;
        vm.bulkMeter = entity;
        vm.mapMeter = createMapMeter(vm.bulkMeter);
        vm.users = UserSearch.searchCollecteur();
        vm.modelMeters = ModelMeter.query({ offset: 0,size: 1000});
        vm.waterNetworks = WaterNetwork.queryFilterArea();
        vm.load = function(id) {
            BulkMeter.get({id : id}, function(result) {
                vm.bulkMeter = result;
                vm.mapMeter = createMapMeter(vm.bulkMeter);
            });
        };

        if (vm.bulkMeter && vm.bulkMeter.$promise) {
            vm.bulkMeter.$promise.then(function() {
                vm.mapMeter = createMapMeter(vm.bulkMeter);
            });
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:bulkMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            syncMapMeter();
            if (vm.bulkMeter.id !== null) {
                BulkMeter.update(vm.bulkMeter, onSaveSuccess, onSaveError);
            } else {
                BulkMeter.save(vm.bulkMeter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateSuppression = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function createMapMeter(bulkMeter) {
            return {
                lat: parseCoordinate(bulkMeter && bulkMeter.latitude),
                lon: parseCoordinate(bulkMeter && bulkMeter.longitude),
                referenceContrat: bulkMeter && bulkMeter.numeroSerie ? bulkMeter.numeroSerie : ''
            };
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = Number(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function formatCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            return String(value);
        }

        function syncMapMeter() {
            vm.bulkMeter.latitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lat);
            vm.bulkMeter.longitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lon);

            if (vm.mapMeter) {
                vm.mapMeter.referenceContrat = vm.bulkMeter.numeroSerie;
            }
        }
    }
})();
